export const FORM_NAME = 'SCHEDULED_EMAIL_EDIT_FORM';
